var LandingPageIcon;
(function (LandingPageIcon) {
    LandingPageIcon["MY_CHART"] = "C";
    LandingPageIcon["MY_PROFILE"] = "P";
    LandingPageIcon["EXAMS_RESULTS"] = "E";
    LandingPageIcon["SCHEDULING"] = "S";
    LandingPageIcon["PATIENT_PREPARATION"] = "A";
    LandingPageIcon["TELECONSULTATION"] = "T";
    LandingPageIcon["POST_PROCEDURE"] = "O";
    LandingPageIcon["CARE_NAVIGATION"] = "N";
    LandingPageIcon["LOGISTIC_SUPPORT"] = "L";
})(LandingPageIcon || (LandingPageIcon = {}));
export default LandingPageIcon;
//# sourceMappingURL=landing-page-icon.js.map